<div class="container">
  <ng-content select="[repeaterHeader]"></ng-content>

  <div class="warn-message">
    <ng-content select="[warnMessageArea]"></ng-content>
  </div>

  <div class="button-box">
    <div fxLayout="row wrap" fxLayoutGap="8px" fxLayoutAlign="start center">
      <ng-content select="[autoCompleteTypeAhead]"></ng-content>

      @if (!usingTypeAheadComponent) {
      <mat-form-field [hidden]="hideAutoComplete">
        <button matPrefix mat-icon-button>
          <mat-icon>search</mat-icon>
        </button>
        <input
          type="text"
          [placeholder]="placeholder"
          matInput
          [formControl]="autocompleteFormControl"
          [matAutocomplete]="auto"
          #autocompleteInput
        />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" #matAutoComplete [displayWith]="displayFn">
          @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option" [matTooltip]="option.label" matTooltipPosition="after" multiLineOption>
            @if (searchResultTemplate) {
            <div>
              <ng-template
                [ngTemplateOutlet]="searchResultTemplate"
                [ngTemplateOutletContext]="{ $implicit: option }"
              ></ng-template>
            </div>
            } @else {
            {{ option.label }}
            }
          </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      } @for (option of stickyOptions; track option) {
      <button
        mat-stroked-button
        [disabled]="disabled || (option | isOptionUsed : selectedOptions)"
        class="option-button"
        (click)="addStickyOption($event, option)"
      >
        {{ stickyOptionValueAsLabel ? option.value : option.label }}
        @if (option | isOptionUsed : selectedOptions) {
        <mat-icon [inline]="true">check</mat-icon>
        } @else {
        <mat-icon [inline]="true">add</mat-icon>
        }
      </button>
      } @if (showAddOtherButton) {
      <button mat-stroked-button color="primary" [disabled]="disabled" class="option-button" (click)="addEmptyGroup()">
        Add Other
        <mat-icon>post_add</mat-icon>
      </button>
      }
    </div>
  </div>

  <div class="header-row">
    @if (repeaterFormArray.length > 0) {
    <ng-content select="[aboveRepeater]"></ng-content>
    }
  </div>

  <div [formGroup]="repeaterFormGroup" class="repeater-row--container" #repeaterRowContainer>
    <ng-container formArrayName="repeaterFormArray">
      @for (item of repeaterFormArray.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        @if (!deleteConfig.softDeleteKey || !item.value[deleteConfig.softDeleteKey]) {
        <div class="row">
          <ng-template
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{
              $implicit: {
                formGroup: item,
                option: item.value.key | findOption : options,
                index: i
              }
            }"
          ></ng-template>
          @if (deleteConfig.showDelete) {
          <button
            mat-icon-button
            color="warn"
            class="delete"
            (click)="deleteCompletedPatientFormRow($event, i, item.value.key)"
            [disabled]="disabled"
          >
            <mat-icon>delete</mat-icon>
          </button>
          }
        </div>
        }
      </div>
      }
    </ng-container>
  </div>

  <div class="note-container">
    <ng-content select="[noteField]"></ng-content>
  </div>
</div>
